import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import HomePageNews from "./News/HomePageNews";
import { PostData } from "../api/service";

const SectionEyebrow = ({ children }) => (
  <span
    style={{
      display: "inline-block",
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 1.6,
      textTransform: "uppercase",
      color: "#2962ff",
      background: "rgba(41, 98, 255, 0.08)",
      padding: "4px 12px",
      borderRadius: 4,
      marginBottom: 12,
    }}
  >
    {children}
  </span>
);

const AccentBar = () => (
  <div
    style={{
      width: 56,
      height: 3,
      backgroundColor: "#2962ff",
      borderRadius: 2,
      marginTop: 14,
    }}
  />
);

const LeadershipCard = ({ eyebrow, title, role, image, link, type, fallback }) => {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    PostData(`/getnoticesbytypedept`, {
      dept_code: "DISPUR",
      type,
      year: "",
    }).then((resp) => {
      setData(Array.isArray(resp) ? resp : []);
      setIsLoaded(true);
    });
  }, [type]);

  const description = data.length > 0 ? data[0].description : "";
  const hasFetched = isLoaded && description;

  return (
    <div
      style={{
        background: "#ffffff",
        border: "1px solid #e6e9ef",
        borderRadius: 16,
        overflow: "hidden",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 8px 30px rgba(10, 31, 68, 0.06)",
      }}
    >
      <div
        style={{
          background:
            "linear-gradient(135deg, #0A1F44 0%, #14306b 60%, #1d3f8a 100%)",
          padding: "28px 24px 24px",
          display: "flex",
          alignItems: "center",
          gap: 18,
          color: "#ffffff",
        }}
      >
        <div
          style={{
            width: 96,
            height: 96,
            borderRadius: "50%",
            overflow: "hidden",
            border: "3px solid rgba(255,255,255,0.18)",
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            flexShrink: 0,
            background: "#ffffff",
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: 1.4,
              textTransform: "uppercase",
              color: "#7eb6ff",
              marginBottom: 6,
            }}
          >
            {eyebrow}
          </div>
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              lineHeight: 1.25,
              marginBottom: 4,
            }}
          >
            {title}
          </div>
          <div
            style={{
              fontSize: 12.5,
              color: "#cfd8e8",
              fontWeight: 500,
            }}
          >
            {role}
          </div>
        </div>
      </div>

      <div
        style={{
          padding: "24px 28px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!isLoaded ? (
          <div style={{ flex: 1 }}>
            <div
              style={{
                height: 12,
                background: "#eef1f6",
                borderRadius: 4,
                marginBottom: 10,
              }}
            />
            <div
              style={{
                height: 12,
                background: "#eef1f6",
                borderRadius: 4,
                marginBottom: 10,
                width: "92%",
              }}
            />
            <div
              style={{
                height: 12,
                background: "#eef1f6",
                borderRadius: 4,
                marginBottom: 10,
                width: "85%",
              }}
            />
            <div
              style={{
                height: 12,
                background: "#eef1f6",
                borderRadius: 4,
                width: "60%",
              }}
            />
          </div>
        ) : hasFetched ? (
          <div
            className="leadership-card-body"
            style={{
              fontSize: 14.5,
              lineHeight: 1.75,
              color: "#3a4256",
              textAlign: "justify",
              flex: 1,
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 8,
              WebkitBoxOrient: "vertical",
            }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : (
          <Typography
            variant="body2"
            style={{
              textAlign: "justify",
              fontSize: 14.5,
              lineHeight: 1.75,
              color: "#3a4256",
              flex: 1,
            }}
          >
            {fallback}
          </Typography>
        )}

        <div style={{ marginTop: 20 }}>
          <Link
            to={link}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "9px 18px",
              background: "linear-gradient(135deg, #2962ff 0%, #5d8bff 100%)",
              color: "#ffffff",
              borderRadius: 8,
              textDecoration: "none",
              fontWeight: 600,
              fontSize: 13.5,
              letterSpacing: 0.3,
              boxShadow: "0 4px 12px rgba(41, 98, 255, 0.3)",
            }}
          >
            Read more <span style={{ fontSize: 16 }}>&rarr;</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

const NewsCardHeader = ({ eyebrow, title }) => (
  <div
    style={{
      borderBottom: "1px solid #e6e9ef",
      padding: "20px 24px 18px",
      background: "linear-gradient(180deg, #f7faff 0%, #ffffff 100%)",
    }}
  >
    <div
      style={{
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 1.4,
        textTransform: "uppercase",
        color: "#2962ff",
        marginBottom: 4,
      }}
    >
      {eyebrow}
    </div>
    <div
      style={{
        fontSize: 18,
        fontWeight: 700,
        color: "#0A1F44",
        lineHeight: 1.2,
      }}
    >
      {title}
    </div>
  </div>
);

export default function HomePageTopDiv() {
  return (
    <div>
      {/* GREETINGS */}
      <section style={{ padding: "48px 0 24px" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 28,
            textAlign: "center",
          }}
        >
          <SectionEyebrow>Welcome</SectionEyebrow>
          <Typography
            variant="h4"
            style={{
              fontWeight: 700,
              color: "#0A1F44",
              margin: 0,
              fontSize: 30,
              lineHeight: 1.25,
              maxWidth: 880,
            }}
          >
            Greetings from the Internship and Apprenticeship Cell, Dispur
            College
          </Typography>
          <AccentBar />
        </div>

        <div
          style={{
            background: "#ffffff",
            border: "1px solid #e6e9ef",
            borderRadius: 16,
            padding: "32px 36px",
            boxShadow: "0 4px 20px rgba(10, 31, 68, 0.04)",
            maxWidth: 980,
            margin: "0 auto",
          }}
        >
          <Typography
            variant="body1"
            style={{
              textAlign: "justify",
              fontSize: 15.5,
              lineHeight: 1.8,
              color: "#3a4256",
              marginBottom: 14,
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The Internship and
            Apprenticeship Cell (IAC-DC), Dispur College extends its greetings
            to all Internship Providing Organisers (IPOs), students, alumni,
            regulators, industry partners, and other stakeholders.
          </Typography>
          <Typography
            variant="body1"
            style={{
              textAlign: "justify",
              fontSize: 15.5,
              lineHeight: 1.8,
              color: "#3a4256",
              marginBottom: 14,
            }}
          >
            The Cell is committed to facilitating a structured interface
            between academic learning and professional practice through
            experiential learning programmes, internships and apprenticeships
            that contribute to skill development, industry exposure, and
            employability enhancement. It recognises the significant role of
            partner organisations in providing mentorship and meaningful
            workplace learning experiences.
          </Typography>
          <Typography
            variant="body1"
            style={{
              textAlign: "justify",
              fontSize: 15.5,
              lineHeight: 1.8,
              color: "#3a4256",
              marginBottom: 14,
            }}
          >
            Students are encouraged to actively participate in and effectively
            utilise the opportunities facilitated by the Cell for their academic
            and professional development.
          </Typography>
          <Typography
            variant="body1"
            style={{
              textAlign: "justify",
              fontSize: 15.5,
              lineHeight: 1.8,
              color: "#3a4256",
              margin: 0,
            }}
          >
            The Cell looks forward to continued collaboration with all
            stakeholders in advancing a robust ecosystem of experiential
            learning.
          </Typography>
        </div>
      </section>

      {/* LEADERSHIP MESSAGES */}
      <section style={{ padding: "32px 0" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 28,
            textAlign: "center",
          }}
        >
          <SectionEyebrow>Leadership</SectionEyebrow>
          <Typography
            variant="h4"
            style={{
              fontWeight: 700,
              color: "#0A1F44",
              margin: 0,
              fontSize: 28,
            }}
          >
            Messages from the Leadership
          </Typography>
          <AccentBar />
        </div>

        <Grid container spacing={3}>
          {/* PRINCIPAL */}
          <Grid item xs={12} md={6}>
            <LeadershipCard
              eyebrow="Principal"
              title="Message from the Principal"
              role="Principal, Dispur College"
              image="/images/dc_principal_new_image_1.jpg"
              link="/about-us/message-from-the-principal"
              type="ABOUTUS_PRINCIPAL_MESSAGE"
              fallback="The Principal's message will be available shortly."
            />
          </Grid>

          {/* COORDINATOR */}
          <Grid item xs={12} md={6}>
            <LeadershipCard
              eyebrow="Coordinator"
              title="Message from the Coordinator"
              role="Coordinator, Internship & Apprenticeship Cell"
              image="/images/SM-pic.png"
              link="/about-us/message-from-the-coordinator"
              type="ABOUTUS_COORDINATOR_MESSAGE"
              fallback="The Coordinator's message will be available shortly."
            />
          </Grid>
        </Grid>
      </section>

      {/* NEWS GRID */}
      <section style={{ padding: "32px 0 16px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e6e9ef",
                borderRadius: 16,
                overflow: "hidden",
                height: "100%",
                boxShadow: "0 4px 20px rgba(10, 31, 68, 0.04)",
              }}
            >
              <NewsCardHeader
                eyebrow="Latest"
                title="News & Updtates"
              />
              <div style={{ padding: "16px 24px 24px" }}>
                <HomePageNews
                  type="COLLEGE_ACADEMIC_NOTICE"
                  link="/notifications/academic"
                />
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e6e9ef",
                borderRadius: 16,
                overflow: "hidden",
                height: "100%",
                boxShadow: "0 4px 20px rgba(10, 31, 68, 0.04)",
              }}
            >
              <NewsCardHeader
                eyebrow="Opportunities"
                title="Jobs/Internships/Events"
              />
              <div style={{ padding: "16px 24px 24px" }}>
                <HomePageNews type="COLLEGE_EVENT" link="/events" />
              </div>
            </div>
          </Grid>
        </Grid>
      </section>
    </div>
  );
}
